import { hollyMediaArray } from './hollyMedia'
import { hollyBio } from './hollyBios'
import { frodoProfileReviewHinge, luigiProfileReviewBumble, gatsbyProfileReviewTinder } from './hollyProfileReviews'

export const hollyDatingProfileHinge = {
  _id: 'hollyDatingProfileHingeId',
  userId: 'hollyUserId',
  email: 'holly@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hollyMediaArray[11]._id,
      mediaItemURL: hollyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[11].type,
      caption: hollyMediaArray[11].captions[0],
      subcaption: hollyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[9]._id,
      mediaItemURL: hollyMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[9].type,
      caption: hollyMediaArray[9].captions[0],
      subcaption: hollyMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[12]._id,
      mediaItemURL: hollyMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[12].type,
      caption: hollyMediaArray[12].captions[0],
      subcaption: hollyMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[5]._id,
      mediaItemURL: hollyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[5].type,
      caption: hollyMediaArray[5].captions[0],
      subcaption: hollyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[4]._id,
      mediaItemURL: hollyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[4].type,
      caption: hollyMediaArray[4].captions[0],
      subcaption: hollyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[1]._id,
      mediaItemURL: hollyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[1].type,
      caption: hollyMediaArray[1].captions[0],
      subcaption: hollyMediaArray[1].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: hollyBio._id,
    vitalInfo: { ...hollyBio.vitalInfo },
    prompts: [
      { ...hollyBio.prompts[0] },
      { ...hollyBio.prompts[1] },
      { ...hollyBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...frodoProfileReviewHinge }
  ],
  mediaItems: [ ...hollyMediaArray ],
  bioItems: { ...hollyBio },
}

export const hollyDatingProfileBumble = {
  _id: 'hollyDatingProfileBumbleId',
  userId: 'hollyUserId',
  email: 'holly@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hollyMediaArray[11]._id,
      mediaItemURL: hollyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[11].type,
      caption: hollyMediaArray[11].captions[0],
      subcaption: hollyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[9]._id,
      mediaItemURL: hollyMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[9].type,
      caption: hollyMediaArray[9].captions[0],
      subcaption: hollyMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[12]._id,
      mediaItemURL: hollyMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[12].type,
      caption: hollyMediaArray[12].captions[0],
      subcaption: hollyMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[5]._id,
      mediaItemURL: hollyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[5].type,
      caption: hollyMediaArray[5].captions[0],
      subcaption: hollyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[4]._id,
      mediaItemURL: hollyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[4].type,
      caption: hollyMediaArray[4].captions[0],
      subcaption: hollyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[1]._id,
      mediaItemURL: hollyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[1].type,
      caption: hollyMediaArray[1].captions[0],
      subcaption: hollyMediaArray[1].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: hollyBio._id,
    vitalInfo: { ...hollyBio.vitalInfo },
    prompts: [
      { ...hollyBio.prompts[0] },
      { ...hollyBio.prompts[1] },
      { ...hollyBio.prompts[2] }
    ],
    aboutMe: hollyBio.aboutMe[0],
    hobbies: [hollyBio.hobbies[0], hollyBio.hobbies[1], hollyBio.hobbies[2], hollyBio.hobbies[3], hollyBio.hobbies[4] ],
  },
  profileReviews: [
    { ...luigiProfileReviewBumble }
  ],
  mediaItems: [ ...hollyMediaArray ],
  bioItems: { ...hollyBio },
}

export const hollyDatingProfileTinder = {
  _id: 'hollyDatingProfileTinderId',
  userId: 'hollyUserId',
  email: 'holly@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: hollyMediaArray[11]._id,
      mediaItemURL: hollyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[11].type,
      caption: hollyMediaArray[11].captions[0],
      subcaption: hollyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[9]._id,
      mediaItemURL: hollyMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[9].type,
      caption: hollyMediaArray[9].captions[0],
      subcaption: hollyMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[12]._id,
      mediaItemURL: hollyMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[12].type,
      caption: hollyMediaArray[12].captions[0],
      subcaption: hollyMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[5]._id,
      mediaItemURL: hollyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[5].type,
      caption: hollyMediaArray[5].captions[0],
      subcaption: hollyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[4]._id,
      mediaItemURL: hollyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[4].type,
      caption: hollyMediaArray[4].captions[0],
      subcaption: hollyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: hollyMediaArray[1]._id,
      mediaItemURL: hollyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: hollyMediaArray[1].type,
      caption: hollyMediaArray[1].captions[0],
      subcaption: hollyMediaArray[1].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: hollyBio._id,
    vitalInfo: { ...hollyBio.vitalInfo },
    prompts: [
      { ...hollyBio.prompts[0] },
      { ...hollyBio.prompts[1] },
      { ...hollyBio.prompts[2] }
    ],
    aboutMe: hollyBio.aboutMe[0],
    hobbies: [hollyBio.hobbies[0], hollyBio.hobbies[1], hollyBio.hobbies[2], hollyBio.hobbies[3], hollyBio.hobbies[4] ],
  },
  profileReviews: [
    { ...gatsbyProfileReviewTinder }
  ],
  mediaItems: [ ...hollyMediaArray ],
  bioItems: { ...hollyBio },
}